import { render, staticRenderFns } from "./template.vue?vue&type=template&id=229b5a41&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=229b5a41&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b5a41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229b5a41')) {
      api.createRecord('229b5a41', component.options)
    } else {
      api.reload('229b5a41', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=229b5a41&scoped=true", function () {
      api.rerender('229b5a41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ScratchJr/template.vue"
export default component.exports